import type { TaskStatus, TaskType } from '@pms/shared';
import { cn } from '@/lib/utils';
import { STATUS_META, TYPE_META } from './taskConstants';

const PILL = 'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold leading-none';

const UNKNOWN_STATUS = 'bg-slate-200 text-slate-600 dark:bg-slate-500/15 dark:text-slate-400';

/**
 * Falls back rather than throwing on an unrecognised status. Statuses were reduced
 * to four and a stray legacy value (from an un-migrated row or a stale cache) would
 * otherwise crash the whole list on `meta.className`.
 */
export function TaskStatusBadge({ status, className }: { status: TaskStatus; className?: string }) {
  const meta = STATUS_META[status];
  if (!meta) return <span className={cn(PILL, UNKNOWN_STATUS, className)}>{status}</span>;
  return <span className={cn(PILL, meta.className, className)}>{meta.label}</span>;
}

export function TaskTypeBadge({ type, className }: { type: TaskType; className?: string }) {
  const meta = TYPE_META[type];
  return <span className={cn(PILL, meta.className, className)}>{meta.label}</span>;
}

/** Compact "D:7" abbreviation chip used on employee cards. */
export function TaskTypeCountChip({ type, count }: { type: TaskType; count: number }) {
  const meta = TYPE_META[type];
  return <span className={cn(PILL, meta.className)}>{meta.abbr}:{count}</span>;
}
